import config from "./config_test";
import prod from "./config_prod";

export default (process.env.REACT_APP_STAGE === "prod" ? prod : config);
